<template>
  <div :class="$style.logoType">
    <div :class="$style.logoTag">shop on campus<span :class="$style.tm">&trade;</span></div>
    <!-- <div :class="$style.logoTag">shop at home</div> -->
    <!-- <div :class="$style.logoTag">Sharing our resources with you</div> -->
    <div :class="$style.logoMark">{{ siteName }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      siteName: 'sites/getSiteName',
    }),
  },
}
</script>

<style lang="scss" module>
@import url('https://fonts.googleapis.com/css?family=Covered+By+Your+Grace|Just+Another+Hand&display=swap');
@import '@design';

.logoType {
  display: inline-block;
  padding: 0 10px;
  vertical-align: middle;
}
.logoTag {
  margin: 0 0 4px 0;
  font-family: 'Covered By Your Grace', 'Just Another Hand', cursive;
  font-size: 22px;
  color: var(--brandColor);
}
.logoTagSub {
  font-size: 24px;
  color: #35495e;
}
.logoMark {
  font-size: 30px;
  font-weight: 900;
  letter-spacing: -1.5px;
}
.tm {
  position: relative;
  top: -6px;
  font-size: 0.4375rem;
}
</style>
